import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.146 18.707L8.44 12l6.707-6.707 1.415 1.414L11.268 12l5.293 5.293-1.415 1.414z" }));
export default createSvgIcon(iconPath, "ArrowStrokeLeft");
//# sourceMappingURL=ArrowStrokeLeftIcon.js.map